module.exports = __webpack_public_path__ + "media/passed30Sound.f5db9d09.wav";